<template>
  <section
    :class="[
      $style.root,
      { [$style.vertical]: vertical },
    ]"
  >
    <div :class="$style.title">
      {{ title }}<span v-if="required">*</span>
    </div>
    <div :class="$style.slot">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    title: {
      type: String,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss" module>
@import '~@/ui-kit/_theme/main.scss';

.root {
  display: flex;
  margin-bottom: $space-large;
  align-items: center;

  &.vertical {
    display: block;

    .title {
      margin-bottom: $gap-xs;
      width: auto;
    }
  }
}

.title {
  width: 190px;
  color: $text-secondary-color;
}

.slot {
  flex-grow: 1;
}
</style>
